import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const createApiMappingBody = (mappingArray: any[]) => {
  return {
    createApiMappingRequestList: mappingArray,
  }
}
const responseParser = (data: any) => {
  return data
}

const createMultipleApiMappingReq = (mappingArray: any[], tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.createApiMapping,
    method: 'POST',
    config: sitConfig(tokens),
    body: createApiMappingBody(mappingArray),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { createMultipleApiMappingReq }
